/** Kept for back-navigation to listing / detail reuse of live-check results (30 min). */
export const SOURCING_KEEP_UNUSED_DATA_SECONDS = 1800;
